/* unplugin-vue-components disabled */import script from "./DishesOrderItemsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DishesOrderItemsCard.vue?vue&type=script&setup=true&lang=js"

import "./DishesOrderItemsCard.vue?vue&type=style&index=0&id=52ab3a78&lang=scss"

const __exports__ = script;

export default __exports__